export default __webpack_public_path__ + "static/Poppins-Bold-cdb29a5d7ccf57ff05a3fd9216d11771.ttf";